import { mapGetters, mapMutations } from "vuex"
import { getSas } from "@/plugins/services/sas"
import TokenContact from "@/mixins/TokenContact"
import { submitSas } from "@/plugins/services/sas"
import { mapActions } from "vuex"
export default {
  mixins: [TokenContact],
  props: {
    steps: {
      type: Array
    },
    step: {
      type: String,
    },
    notNumbered: {
      type: Boolean,
      default: true
    },
    showPanier: {
      type: Boolean,
      default: false
    },
    estFormulairePublic: { type: Boolean, default: false },
    url: String,
    paramsName: String,
    endpoint: String,
    getRefs: Object
  },

  data() {
    return {
      loading: false,
      formulaireNonValide: false,
      validationBackendFailed: false,
      soumissionEchouee: false,
      messageSoumissionEchouee: null,
    }
  },

  created() {
    this.createdMethod()
  },

  computed: {
    ...mapGetters(["sas", "panier", "ressources"]),

    realSteps() {
      return this.steps.filter((s) => s.path != "introduction" && s.path != "soumission")
    },

    currentStep() {
      return this.findStep(this.step)
    },

    canSubmit() {
      return this.steps.every((s) => s.state == "success")
    },
  },

  methods: {
    ...mapMutations(["SET_SAS"]),
    ...mapActions(["fetchPanier"]),

    async createdMethod() {
      // On reset le sas du store pour s'assurer qu'on a pas conservé les données d'un formulaire précédent.
      this.SET_SAS(null)
      this.checkStep()
      await this.loadToken()
      await this.loadParams(this.paramsName)
      if (this.estFormulairePublic || this.loadContact()) {
        this.loading = true
        if (await this.loadSas()) {
          if (this.showPanier && this.sas.id) {
            this.fetchPanier({ endpoint: this.endpoint, sasId: this.sas.id })
          }
        }
        this.loading = false
      }
    },

    checkStep() {
      if (this.steps.map((s) => s.path).indexOf(this.step) == -1) {
        this.firstStep()
      }
    },
    async loadSas() {
      let result = false
      if (this.$route.query.sasId) {
        result = await getSas(this.url, this.$route.query.sasId).then((res) => {
          if (res.data.erreur) {
            this.$router.push({ path: "/formulaire-deja-soumis" })
            return false
          } else {
            this.SET_SAS(res.data)
            return true
          }
        })
      } else {
        if (!this.$route.fullPath.includes(this.steps[0].path)) {
          this.firstStep()
        }
        result = false
      }
      return result
    },

    firstStep() {
      this.$router.push({
        path: this.url + this.steps[0].path,
        query: this.$route.query,
      })
    },

    next() {
      this.validateStep(this.currentStep)
      if (!this.panier && this.showPanier) {
        this.fetchPanier({ endpoint: this.endpoint, sasId: this.sas.id })
      }
      this.$vuetify.goTo(0)
      this.formulaireNonValide = false
      this.$router.push({
        path: this.url + this.steps[this.steps.findIndex((s) => s.path == this.step) + 1].path,
        query: { ...this.$route.query },
      })
    },

    setState(step, state) {
      this.findStep(step).state = state ? "success" : "warning"
    },

    findStep(step) {
      return this.steps.find((s) => s.path == step)
    },

    validate() {
      let ok = true
      for (let i = 0; i < this.steps.length; i++) {
        const stepValid = this.validateStep(this.steps[i])
        ok = stepValid && ok
      }
      return ok
    },

    validateStep(step) {
      let stepValid = true
      let stepRefs = this.getRefs[step.path]
      if (stepRefs) {
        let stepRef = undefined
        if (stepRefs.length == 1) {
          stepRef = stepRefs[0]
        } else {
          stepRef = stepRefs
        }
        
        let stepMainForm = stepRef.$refs.mainForm
        if (stepMainForm) {
          const mainFormValid = stepMainForm.validate()
          stepValid = stepValid && mainFormValid
        }

        const dataIteratoValid = this.validateDataIterator(stepRef.$refs.dataIterator)
        stepValid = stepValid && dataIteratoValid

        let nestedDataIterators = Object.keys(stepRef.$refs).filter((r) => r.startsWith("dataIterator"))
        nestedDataIterators.forEach((key) => {
          const nestedDataIteratorValid = this.validateDataIterator(stepRef.$refs[key]?.$refs.dataIterator)
          stepValid = stepValid && nestedDataIteratorValid
        })
        
        // Validation de l'étape personnalisée
        if (stepRef.isValid !== undefined) {
          stepValid = stepValid && stepRef.isValid
        }
      }
      return stepValid
    },
    validateDataIterator(dataIteratorRef) {
      if (!dataIteratorRef) {
        return true
      }

      let isValid = true

      let iteratorFormsKeys = Object.keys(dataIteratorRef.$refs).filter((r) => r.startsWith("iteratorForm_"))
      iteratorFormsKeys.forEach((key) => {
        let form = dataIteratorRef.$refs[key][0]
        if (form) {
          const formValid = form.validate()
          isValid = isValid && formValid
        }
      })
      return isValid
    },
    async submit() {
      this.formulaireNonValide = false
      this.validationBackendFailed = false
      this.soumissionEchouee = false
      this.messageSoumissionEchouee = null
      const isValid = this.validate()
      if (isValid) {
        this.loading = true
        const res = await submitSas(this.endpoint, this.sas.id)
        if (res.data.validationFailed) {
          this.loading = false
          this.validationBackendFailed = true
          return
        }

        // Le plan de soumission a échoué côté serveur : rien n'est enregistré, le membre doit le savoir
        if (!res.data.success) {
          this.loading = false
          this.soumissionEchouee = true
          this.messageSoumissionEchouee = res.data.message
          return
        }

        if (res.data.traite) {
          this.$router.push({
            name: "FormulaireTraite",
            params: { idFacture: res.data.facture },
          })
        } else {
          this.$router.push({
            name: "FormulaireSoumis",
            params: { idFacture: res.data.facture },
          })
        }

        this.loading = false
      } else {
        this.formulaireNonValide = true
      }
    },
  },
  mounted() {
    if (this.sas) {
      this.findStep("introduction").state = "success"
    }
  },
}
